import { dateTimeFromServer } from '../utils/format'
import { JSON } from '../utils/types'
import { PaymentMethod } from './PaymentMethod'

export default class Oxxo extends PaymentMethod {
  readonly barcode: string
  readonly formattedExpirationDate: string
  readonly barcodeBase64Image: string
  readonly sentTo: string

  constructor(data: JSON) {
    super(data)
    this.barcode = data.barcode
    this.formattedExpirationDate = dateTimeFromServer(this.expirationDate, true)!
    this.barcodeBase64Image = data.barcode_base64_image
    this.sentTo = data.sent_to
  }
}
